/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// EMBEDS : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
    embeds: {
    	'& #subhead': {
            '& .embedheadername': {
                marginRight: pxToEm(15),
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                '& .embedname': {
                    animationDelay: '1.1s',
                }, 
            },
    		
            '& .ctas': {
                '& .link': {
                    animationDelay: '1.1s',
                    '& .loader': {
                        '& div': { borderTopColor: '#fff' }
                    }
                }
            }
    	}
    }
});